import DefaultsubjectIcon from "Assets/Images/default_subject-icon.png";
import React from "react";
import styled from "styled-components";
import {
  subjectBorderColorCode,
  subjectColorCode,
} from "utilFunctions/Constants/Constants";
const subjectIcon: any = {
  Physics:
    "https://d3vo8rtp78h2dc.cloudfront.net/lcmsnode/subject-icon/1705049613120Subject icon-round=Physics.png",
  Chemistry:
    "https://content-aakash.s3.ap-south-1.amazonaws.com/lcmsnode/subject-icon/1705049278281Subject icon-round=Chemistry.png",
  Mathematics:
    "https://content-aakash.s3.ap-south-1.amazonaws.com/lcmsnode/subject-icon/1705049290098Subject icon-round=Maths.png",
  Biology:
    "https://content-aakash.s3.ap-south-1.amazonaws.com/lcmsnode/subject-icon/1705049428162Subject icon-round=Biology.png",
  Botany:
    "https://d3vo8rtp78h2dc.cloudfront.net/lcmsnode/subject-icon/1705049411875Subject icon-round=Botany.png",
  "Mental Ability":
    "https://content-aakash.s3.ap-south-1.amazonaws.com/lcmsnode/subject-icon/1705049456712Subject icon-round=MAT.png",
  English:
    "https://content-aakash.s3.ap-south-1.amazonaws.com/lcmsnode/subject-icon/1705049531132Subject icon-round=English Language.png",
  "Social Science":
    "https://content-aakash.s3.ap-south-1.amazonaws.com/lcmsnode/subject-icon/1705049640579Subject icon-round=Social Science.png",
  Zoology:
    "https://d3vo8rtp78h2dc.cloudfront.net/lcmsnode/subject-icon/1705049686753Subject icon-round=Zoology.png",
  Geography:
    "https://d3vo8rtp78h2dc.cloudfront.net/lcmsnode/subject-icon/1705049510350Subject icon-round=Geography.png",
};
const SubjectDiv = styled<any>("div")`
  background-color: ${(props: any) => props.color} !important;
  border-radius: 8px !important;
  border: 1px solid ${(props: any) => props.bordercolor} !important;
  padding: 6px 12px 6px 12px !important;
  width: 100% !important;
  cursor: pointer !important;
  display: flex !important;
  flex--direction: row !important;
  justify-content: space-around !important;
  align-items: center !important;
`;
const returnSubjectsColor: any = (subject: any, isSelected: any) => {
  const bgColor = isSelected ? subjectColorCode[subject] : "transparent";
  const borderColor = isSelected ? subjectBorderColorCode[subject] : "#AFAFAF";
  return { bgColor, borderColor };
};

interface ICourseSelection {
  courseDetails?: any;
  selectedCourses?: any;
  setSelectedCourses?: any;
  handleCourseSelectionForChapter?: any;
}
function CourseSelectionMainPage({
  courseDetails,
  selectedCourses,
  setSelectedCourses,
  handleCourseSelectionForChapter,
}: ICourseSelection) {
  const handleCourseSelection = (item: any) => {
    handleCourseSelectionForChapter(item);
    setSelectedCourses(item);
  };
  return (
    <>
      <div className="d-flex pt-3 flex-row subject-container-main-div">
        {courseDetails.map((item: any, index: number) => {
          const { bgColor, borderColor } = returnSubjectsColor(
            item.subject_name,
            selectedCourses.id == item.id
          );
          return (
            <SubjectDiv
              key={index}
              className="d-flex flex-row border p-2 mr-3"
              color={bgColor}
              bordercolor={borderColor}
              onClick={() => {
                handleCourseSelection(item);
              }}
            >
              <div className="image-container-style">
                {item.icon ? (
                  <img
                    src={item.icon}
                    height={18}
                    width={18}
                    alt={"subject icon"}
                  ></img>
                ) : subjectIcon[item.subject_name] ? (
                  <img
                    src={subjectIcon[item.subject_name]}
                    height={18}
                    width={18}
                    alt={"subject icon"}
                  ></img>
                ) : (
                  <img
                    src={DefaultsubjectIcon}
                    height={18}
                    width={18}
                    alt={"subject icon"}
                  ></img>
                )}
              </div>
              <div
                className="no-wrap-content subject-name-styling"
                style={{
                  color: selectedCourses.id == item.id ? "#545454" : "#757575",
                }}
              >
                &nbsp;{item.subject_name}{" "}
                {item?.progress_percentage != undefined &&
                item?.progress_percentage != null
                  ? "|"
                  : ""}
              </div>
              {item?.progress_percentage != undefined &&
                item?.progress_percentage != null && (
                  <span
                    className="no-wrap-content percentage-styling"
                    style={{
                      color:
                        selectedCourses.id == item.id ? "#545454" : "#757575",
                    }}
                  >
                    &nbsp;
                    {item.progress_percentage <= 1
                      ? item.progress_percentage.toFixed()
                      : Math.floor(Number(item.progress_percentage))}
                    %{selectedCourses.id == item.id ? "Completed" : ""}
                  </span>
                )}
            </SubjectDiv>
          );
        })}
      </div>
    </>
  );
}

export default CourseSelectionMainPage;
